import { Color } from 'three';

export function isWhite(color: Color) {
  return color.r === 1 && color.g === 1 && color.b === 1;
}
